import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { ItemCard } from "../../components/containers/item-card";
import { CartAddForm } from "../../components/utils/cart-add-form";
import { DarkBg } from "../../components/containers/dark-bg";
import { useProduct } from "../../../services/products/product.context";
import { FooterComponent } from "../../components/footer/footer";
import { ProductCard } from "../../components/cards/product.card";

export const WhishList = () => {

    const { cart, wishList, addTowishList } = useProduct();

    const [openCart, setOpenCart] = useState(false);
    const [picked, setPicked] = useState();

    const navigateTo = useNavigate();


    const getCartElement = (elem) => {
        const cartElem = cart?.find((val) => val._id === elem._id);
        if (cartElem) {
            return cartElem;
        }
        return elem;
    }

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'WISH LIST'} />
            {openCart && (
                <DarkBg>
                    <CartAddForm
                        itemData={picked}
                        closeCart={() => setOpenCart(false)}
                        opened={openCart}
                        cart={cart}
                    />
                </DarkBg>
            )}
            <div className="thin-text sp-3-st">Éléments enregistrés</div>
            <div className="slogan-1 sp-3-st">Liste d'envies</div>
            {wishList?.length ?
                <div className="catalog">
                    {wishList?.map((item) => (
                        <ProductCard
                            key={item?._id}
                            onCartAdd={() => {
                                const elem = getCartElement(item);
                                setPicked(elem);
                                setOpenCart(true);
                            }}
                            onLike={() => addTowishList(item)}
                            item={item}
                            cart={cart}
                            wishList={wishList}
                            onClick={() => navigateTo("/details", { state: item })}
                        />
                    ))}
                </div> :
                <div className="no-product sp-3-st">
                    <div className="slogan-2">Aucun produit dans ma liste d'envies'</div>
                </div>
            }
            <FooterComponent />
        </div>
    )
}